import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import PopupWithSidebar from "../../../../../components/Popups/PopupWithSidebar/PopupWithSidebar.tsx";
import TgBestPracticesContent from "../../../BestPractices/Content/TgBestPracticesContent.tsx";

export type BestPracticesPopupProps = {
	open: boolean;
	onClose: () => void;
};

const BestPracticesPopup = ({ open, onClose }: BestPracticesPopupProps) => {
	const { t } = useTranslation("tg", { keyPrefix: "models.popups.bestPractices" });

	const sideMenuButtons = [
		{
			title: t("taps.overview.title"),
			id: t("taps.overview.id"),
		},
		{
			title: t("taps.datasetSize.title"),
			id: t("taps.datasetSize.id"),
		},
		{
			title: t("taps.diversityAndFocus.title"),
			id: t("taps.diversityAndFocus.id"),
		},
		{
			title: t("taps.imageQuality.title"),
			id: t("taps.imageQuality.id"),
		},
		{
			title: t("taps.assetsBackgrounds.title"),
			id: t("taps.assetsBackgrounds.id"),
		},
		{
			title: t("taps.captionsAndPrefix.title"),
			id: t("taps.captionsAndPrefix.id"),
		},
		{
			title: t("taps.restylePortraits.title"),
			id: t("taps.restylePortraits.id"),
		},
	];
	const handleCloseDialog = () => {
		localStorage.removeItem("guidelineActiveTap");
		onClose();
	};

	return (
		<PopupWithSidebar
			sideMenuButtons={sideMenuButtons}
			selectedLink={localStorage.getItem("guidelineActiveTap")}
			handleCloseDialog={handleCloseDialog}
			open={open}
		>
			<TgBestPracticesContent />
		</PopupWithSidebar>
	);
};

const ObservedComponent = observer(BestPracticesPopup);
export default ObservedComponent;
